/**
 * @deprecated remove this when splash page QuickSearch is migrated to UDS
 */
export * as Item from './Item'
